import { RightColumnVariant } from './types';

export const defaultVariant: RightColumnVariant = {
  title: 'For designers by designers',
  benefits: [
    'Advanced vector and text editing tools for professional results',
    'Real-time collaboration to create and iterate with others',
    'Infinite customizable artboards, AI companion tools, and more',
    'Thousands of free premium fonts, templates, and design assets',
  ],
  background: '/images/updatedBrands.png',
};
